import { createSelector } from 'reselect';
import { useReportEntityIds } from 'modules/campaigns/hooks/useReportEntityIds';
import { campaignsGroupStateSelector, campaignsGroupMapSelector } from './baseCampaignsGroupSelectors';

/**
 * @deprecated - use useReportEntityIds
 */
export const selectedCampaignGroupIdSelector = useReportEntityIds.createSelector();

export const editedCampaignsGroupSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupMapSelector,
    (campaignsGroupState, campaignsGroupMap) =>
        (campaignsGroupState.campaignsGroupBeingEdited === null
            ? null
            : campaignsGroupMap[campaignsGroupState.campaignsGroupBeingEdited]) || null
);

export const campaignsGroupModuleStatusSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupState => campaignsGroupState.moduleStatus
);

export const campaignsGroupPickerForceReloadFlagSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupState => campaignsGroupState.forceCampaignPickerReloadFlag
);
